import React from 'react';
import FeaturesSection from '../components/FeaturesSection';

const AboutPage = () => {
    return(
        <div>
            <FeaturesSection />
        </div>
    )
}

export default AboutPage;